import React, { useState } from 'react';
import { PageTitle, TblConekta } from '../../components';
import { Card, Col, Nav, Row, Tab } from 'react-bootstrap';
import TblOpenPay from '../../components/finanzas/TblOpenPay';

const OpenPayPg = () => {
    const [activeTab, setActiveTab] = useState('openpay');
    const handleTabChange = (selectedKey) => setActiveTab(selectedKey);

    return (
        <div>
            <PageTitle
                breadCrumbItems={[
                    { label: 'Finanzas', path: '/' },
                    { label: 'Pasarelas', path: '/admin/pasarelas', active: true },
                ]}
                title={'Pasarelas de pago'}
            />

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Tab.Container defaultActiveKey="openpay" activeKey={activeTab} onSelect={handleTabChange}>
                                <Nav variant="tabs" className="nav-bordered" as="ul">
                                    <Nav.Item as="li">
                                        <Nav.Link eventKey="openpay">
                                            <i className="mdi mdi-cash" /> OpenPay
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link eventKey="conekta">
                                            <i className="mdi mdi-cash" /> Oxxo
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>

                                <Tab.Content>
                                    <Tab.Pane eventKey="openpay">
                                        <TblOpenPay />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="conekta">
                                        <TblConekta />
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default OpenPayPg;
